import MercuryTranslationsUtils from '../MercuryTranslationsUtils';
import mercuryUtils from '../../../badge/utils/mercuryUtils';
import { TranslationOptions, UndoOptional } from '../../types';
import { TRANSLATIONS_HELPER_VALUE } from '../../../common/enums';
import { FULL_METADATA_MODE_QUERY_PARAM, PARTIAL_METADATA_MODE_QUERY_PARAM } from '../../../common/constants';

class TranslationsConfigStore {
  private _utilsInstance?: MercuryTranslationsUtils;

  get utilsInstance(): MercuryTranslationsUtils {
    return this._utilsInstance!;
  }

  getRemovedSessionParams(options: UndoOptional<TranslationOptions['urlParams']>) {
    const FALSE = TRANSLATIONS_HELPER_VALUE.FALSE;
    const isIntendedToDisableFull = mercuryUtils.getUrlParam(options.fullMode) === FALSE;
    const isIntendedToDisablePartial = mercuryUtils.getUrlParam(options.partialMode) === FALSE;

    if (isIntendedToDisableFull) {
      sessionStorage.removeItem(FULL_METADATA_MODE_QUERY_PARAM);
    }
    if (isIntendedToDisablePartial) {
      sessionStorage.removeItem(PARTIAL_METADATA_MODE_QUERY_PARAM);
    }
    return [isIntendedToDisableFull, isIntendedToDisablePartial];
  }

  checkEnabledInParamOrInSession(key: string, value: string, wasParamToggledOff?: boolean) {
    if (wasParamToggledOff) {
      return false;
    }
    const isParamEnabled = mercuryUtils.getUrlParam(value) === TRANSLATIONS_HELPER_VALUE.TRUE;
    return isParamEnabled || sessionStorage.getItem(key) === TRANSLATIONS_HELPER_VALUE.TRUE;
  }

  getAndInitializeMode(key: string, value: string, wasParamToggledOff?: boolean) {
    const isModeEnabled = this.checkEnabledInParamOrInSession(key, value, wasParamToggledOff);
    if (isModeEnabled) {
      sessionStorage.setItem(key, TRANSLATIONS_HELPER_VALUE.TRUE);
    }
    return isModeEnabled;
  }

  initialize(options: TranslationOptions['urlParams']) {
    if (!options) {
      return;
    }
    this._utilsInstance = new MercuryTranslationsUtils();

    const [wasFullModeToggledOff, wasPartialModeToggledOff] = this.getRemovedSessionParams(options);
    const isFullMode = this.getAndInitializeMode(FULL_METADATA_MODE_QUERY_PARAM, options.fullMode, wasFullModeToggledOff);
    const isPartialMode = this.getAndInitializeMode(
      PARTIAL_METADATA_MODE_QUERY_PARAM,
      options.partialMode,
      wasPartialModeToggledOff
    );

    this.utilsInstance.setupMetadataMode({ fullMetadataMode: isFullMode, partialMetadataMode: isPartialMode });
  }

  shouldUseTranslationMetadata() {
    const noModeSelected = !this._utilsInstance?.partialMetadataMode && !this._utilsInstance?.fullMetadataMode;
    return this._utilsInstance && !noModeSelected;
  }
}

export default TranslationsConfigStore;
